/**
 * 正算：已知电机 + 传动参数，求电缸推力与速度
 *
 * 公式（与现有桌面计算程序一致）：
 *   F (KG)    = T × η × 2π × i × 1000 / L / g
 *   S (mm/s)  = R / 60 × L / i
 *   i         = reducerRatio × syncDecRatio / syncIncRatio
 *   P_motor   = T × 2π × R / 60     [W]
 *
 * 验证：T=5, R=3000, L=5, i_red=1, i_dec=1.2, i_inc=1
 *   F ≈ 640.88 KG, S ≈ 208.33 mm/s （与截图程序输出一致）
 */
import { DEFAULT_EFFICIENCY, DEFAULT_GRAVITY } from './product-spec.js';
const TWO_PI = 2 * Math.PI;
export function calcForward(input) {
    const { motorTorque, motorSpeed, lead, reducerRatio = 1, syncDecRatio = 1, syncIncRatio = 1, efficiency = DEFAULT_EFFICIENCY, gravity = DEFAULT_GRAVITY, } = input;
    if (motorTorque <= 0)
        throw new Error('motorTorque must be > 0');
    if (motorSpeed <= 0)
        throw new Error('motorSpeed must be > 0');
    if (lead <= 0)
        throw new Error('lead must be > 0');
    if (syncIncRatio <= 0)
        throw new Error('syncIncRatio must be > 0');
    const totalRatio = (reducerRatio * syncDecRatio) / syncIncRatio;
    const thrust = (motorTorque * efficiency * TWO_PI * totalRatio * 1000) / lead / gravity;
    const speed = (motorSpeed / 60) * (lead / totalRatio);
    const motorPower = (motorTorque * TWO_PI * motorSpeed) / 60;
    return { thrust, speed, totalRatio, motorPower };
}
//# sourceMappingURL=forward.js.map